import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { AppState } from '@/types';

const initialState: AppState = {
  loading: false,
  error: null,
  networkStatus: 'online',
};

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setNetworkStatus: (state, action: PayloadAction<'online' | 'offline'>) => {
      state.networkStatus = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
  },
});

export const { setLoading, setError, setNetworkStatus, clearError } = appSlice.actions;
export default appSlice.reducer;